// App.jsx
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Home from "./Components/Home";
import About from "./Components/About";
import Services from "./Components/Services";
import Contact from "./Components/Contact";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Whyus from "./Components/Whyus";
import Seo from "./Components/Seo";
import Ethics from "./Components/Ethics";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <div className="cs-5">
        <ScrollToTop />
        <Navbar />
        <Seo
          title="Randeva Advisory Services Pvt Ltd"
          description="Randeva Advisory Services Pvt Ltd is a Private Limited establishment with over 15 years of experience in the recovery and collection sector."
          keywords="Randeva Advisory Services, Dues Collection & Recovery, Contact Point Verification, Strategic Advisory, Turnover Excellence"
        /> 
        <div className="container mx-auto p-4 mt-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/whyus" element={<Whyus />} />
            <Route path="/ethics" element={<Ethics />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
